<template>
  <div>
    <div class="HeatMap" ref="map"></div>  
    <div class="HeatMapMask" v-show="flag"></div>
  </div>
  
</template>

<script>
export default {
  data() {
    return {
      map: null,
      flag: true
    };
  },
  mounted() {
    this.initMap();
  },

  methods: {
    //延迟渲染地图
    async initMap() {
      await this.$nextTick();
      await this.$sleep();

      var cluster, markers = []
      this.map = new AMap.Map(this.$refs.map, {
        center: [85.1220703100, 35.2456190900],
        zoom: document.body.clientWidth > 1600 ? 4 : 3,
        mapStyle: 'amap://styles/dark'
      });

      this.map.on('complete', () => {
        this.flag = false
      })

      let data = await this.$API.getOnOfflineReport({
        beginOffTimeMin: 0,
        endOffTimeMin: 1296000,
        status: -2,
        pageNumber: 1,
        pageSize: 100000,
        flag: 0,
        chooseId: 0,
        groupId: 0
      });

      let points = [] //posList
      data.data.forEach(element => {
        if (element.lat!=0 && element.lon != 0) {
          points.push({
            lnglat: new AMap.LngLat(element.lon,element.lat)
          })
        }
      })

      for (var i = 0; i < points.length; i += 1) {
        const size = 30 + Math.floor(Math.random() * 20);
        const offset = -size / 2;
        markers.push(new AMap.Marker({
          position: points[i]['lnglat'],
          content: `<div class="dotPulse" style="width: ${size}px;height: ${size}px;">
          <div class="dotPulse__dot"></div>
          <div class="dotPulse__pulse"></div>
          </div>`,
          offset: new AMap.Pixel(offset, offset)
        }))
      }

      if (cluster) {
        cluster.setMap(null);
      }
      this.map.plugin(["AMap.MarkerClusterer"],() => {
        cluster = new AMap.MarkerClusterer(this.map, markers, {
          gridSize: 100
        });
      })

    },
  }
};
</script>

<style lang="scss" scoped>
.HeatMap {
  width: 100%;
  height: 100vh;
  position: relative;
}
.HeatMapMask {
  width: 100%;
  height: 100vh;
  position: fixed;
  background: #2A2A2A;
  top: 60px;
  left: 0;
}
</style>

<style lang="scss">
@keyframes pulse {
  0% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0;
  }

  25% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0.1;
  }

  50% {
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
    opacity: 0.3;
  }

  75% {
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    opacity: 0.5;
  }

  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0;
  }
}

.dotPulse {
  position: relative;
  width: 88px;
  height: 88px;

  &__dot {
    position: absolute;
    width: 10px;
    height: 10px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: rgba(24, 98, 220, 1);
    z-index: 2;
  }

  &__pulse {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(24, 98, 220, 1);
    border-radius: 50%;
    z-index: 1;
    opacity: 1;
    animation: pulse 2s ease-out;
    animation-iteration-count: infinite;
  }
}
</style>
